/* Foreverings -- "Complete the set" block on the wishlist page.
   Added 2026-08-27. Loaded only on /apps/wishlist, from js-variables.liquid.
   Data source: templates/product.wishlist-set.liquid

   WHAT THIS SHOWS AND WHY IT IS NARROW
   custom.matching_set is a set-membership graph, not a partner-pairing graph.
   Its own admin description reads "Couples sets containing this ring". So on a
   single ring it lists the couples sets that ring belongs to -- a genuine
   upsell -- but on a couples set it lists the two rings inside it, which would
   advertise the parts of the thing the customer already saved, at a lower
   price. The block is therefore shown ONLY on products with size options, via
   the endpoint's `sized` flag. That also excludes necklaces and earrings, which
   are single-variant and have no references anyway.

   Do not relabel this "the matching band". The other end of the reference is
   the SET, never the partner's ring -- checked across a dozen families.

   SETS ALREADY IN THE WISHLIST ARE STILL COUNTED AND STILL SHOWN.
   An earlier version hid them, which made the label lie: a ring that belongs to
   three sets read "Sold in 2 sets" once the customer had saved one of them. How
   many sets a ring belongs to is a fact about the ring, not about the wishlist.

   HOW MANY ARE NAMED
   One or two sets are shown in full -- picture, name, price, link -- because at
   that size there is no reason to abbreviate. Three or more would make the card
   very tall, so the first is named and the rest become thumbnails with an
   overflow count. The order is the curated drag order from the metafield.

   INJECTION POINT
   The block goes inside .wk-form, immediately before the button. That matters:
   .wk-form stretches and the button carries margin-top:auto, so the button
   stays pinned to the bottom of every card regardless of how tall this block
   is, and the row of buttons keeps lining up. Putting it after the form would
   push the button off that line. */

(function () {
  var MAX_RENDERS = 300;
  var NAME_ALL_UP_TO = 2;
  var renders = 0;
  var cache = {};
  var inflight = {};

  function handleOf(card) {
    var a = card.querySelector('.wk-image-link');
    if (!a) return null;
    var m = String(a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
    return m ? m[1] : null;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function namedLine(s) {
    return '<a class="fe-set-line" href="' + esc(s.url) + '">' +
        '<img class="fe-set-img" src="' + esc(s.image) + '" alt="" loading="lazy">' +
        '<span class="fe-set-nm"><b>' + esc(s.title) + '</b>' +
        '<span class="fe-set-pr">' + esc(s.price) + '</span></span>' +
        '<span class="fe-set-go">View</span>' +
      '</a>';
  }

  function blockMarkup(sets) {
    var label = sets.length === 1 ? 'Complete the set' : 'Sold in ' + sets.length + ' sets';
    var body = '';

    if (sets.length <= NAME_ALL_UP_TO) {
      sets.forEach(function (s) { body += namedLine(s); });
    } else {
      body += namedLine(sets[0]);
      var rest = sets.slice(1, 4);
      var extra = sets.length - 1 - rest.length;
      body += '<div class="fe-set-thumbs">';
      rest.forEach(function (s) {
        body += '<a href="' + esc(s.url) + '" aria-label="' + esc(s.title) + '">' +
                '<img src="' + esc(s.image) + '" alt="" loading="lazy"></a>';
      });
      if (extra > 0) body += '<span class="fe-set-more">+' + extra + '</span>';
      body += '</div>';
    }

    return '<div class="fe-set">' +
      '<span class="fe-set-lab">' + label + '</span>' + body + '</div>';
  }

  function place(card, sets) {
    if (renders >= MAX_RENDERS) return;
    var form = card.querySelector('.wk-form');
    var cta = card.querySelector('.wk-cta-button');
    if (!form || !cta || cta.parentNode !== form) return;

    var holder = document.createElement('div');
    holder.className = 'fe-set-wrap';
    holder.innerHTML = blockMarkup(sets);
    form.insertBefore(holder, cta);
    renders++;
  }

  function hydrate(page) {
    [].forEach.call(page.querySelectorAll('wishlist-product-card'), function (card) {
      if (card.querySelector('.fe-set-wrap')) return;

      var handle = handleOf(card);
      if (!handle) return;

      var data = cache[handle];

      if (data === undefined) {
        if (inflight[handle]) return;
        inflight[handle] = true;
        fetch('/products/' + handle + '?view=wishlist-set', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (json) {
            cache[handle] = json || null;
            delete inflight[handle];
            hydrate(page);
          });
        return;
      }

      if (!data || !data.sized || !data.sets || !data.sets.length) return;

      var usable = data.sets.filter(function (s) {
        return s && s.url && s.available !== false;
      });
      if (!usable.length) return;

      place(card, usable);
    });
  }

  function start() {
    var page = document.querySelector('wishlist-page');
    if (!page) return false;
    hydrate(page);
    new MutationObserver(function () { hydrate(page); })
      .observe(page, { childList: true, subtree: true });
    return true;
  }

  function boot() {
    if (start()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (start() || ++tries > 60) clearInterval(timer);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
